export const dataURLtoFile = async (url: string, filename: string) => {
    const res = await fetch(url);
    const buf = await res.arrayBuffer();
    return new File([buf], filename, {
        type: url.split(';')[0].split(':')[1],
    });
};
